import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Download = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M11.39 16.94c.17.17.38.25.6.25.22 0 .44-.08.6-.25l4.67-4.67c.33-.33.33-.87 0-1.2a.851.851 0 0 0-1.2 0l-3.21 3.21V4.11a.85.85 0 1 0-1.7 0v10.18l-3.22-3.22a.851.851 0 0 0-1.2 0c-.33.33-.33.87 0 1.2l4.67 4.67h-.01ZM20 18.51H4.04a.85.85 0 1 0 0 1.7H20a.85.85 0 1 0 0-1.7Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Download
